import { gql } from '@apollo/client'

export const REGISTER_USER = gql`
  mutation registerUserUsingEmail($input: RegisterUserUsingEmailInput!) {
    registerUserUsingEmail(input: $input) {
      userId
      apiAccessToken {
        tokenString
        expiresAt
      }
      errors {
        message
        code
      }
    }
  }
`
